import React, { useState } from "react";
import { Label, Button } from "reactstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { toast } from "react-toastify";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HandleMoveStudentsToClass } from "../../actions/teacherMutations";
import Select from "react-select";
import { compareByName } from "../../Utilities/sortHelper";
import { formatServiceError } from "../../Utilities/serviceErrorHelper";

const MoveStudentsToClassForm = (props) => {
  const intl = useIntl();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedStudentIds, setSelectedStudentIds] = useState([]);
  const [validationError, setValidationError] = useState(null);
  const mutateMoveStudents = useMutation({ mutationFn: HandleMoveStudentsToClass });
  const queryClient = useQueryClient();

  const handleChange = (selected) => {
    let studentsToAdd = [];
    selected.forEach((selectedStud) => {
      studentsToAdd.push(selectedStud.id);
    });
    setValidationError(null);
    setSelectedStudentIds(studentsToAdd);
  };

  const handleSubmit = () => {
    if (selectedStudentIds.length < 1) {
      setValidationError(<FormattedMessage id="YouHaveToSelectOneStudent" />);
    } else {
      setValidationError(null);
      setIsSubmitting(true);

      mutateMoveStudents.mutate(
        {
          selectedStudentIds: selectedStudentIds,
          classId: props.classId,
        },
        {
          onSuccess: () => {
            toast.success(<FormattedMessage id="StudentsMoved" />);
            queryClient.invalidateQueries({ queryKey: ["FetchTeacherInformation"] });
            queryClient.invalidateQueries({ queryKey: ["FetchClassByClassId", props.classId] });
            setIsSubmitting(false);
            props.dismissModal();
          },
          onError: (err) => {
            toast.warn(formatServiceError(intl, err?.response?.data));
            setIsSubmitting(false);
          },
        }
      );
    }
  };

  const getFilteredStudents = () => {
    var students = [];
    props.students.forEach((s) => {
      if (props.existingStudents.findIndex((es) => es.id === s.id) === -1) {
        students.push(s);
      }
    });
    return students.sort(compareByName);
  };

  return (
    <div className="col-12 col-sm-12">
      <Label>
        <FormattedMessage id="ChooseOneOrMoreStudents" />
      </Label>
      <Select
        isMulti
        onChange={(selected) => handleChange(selected)}
        options={getFilteredStudents().map((option) => ({
          ...option,
          label: option.name,
          value: option.id,
          clearableValue: true,
        }))}
      />
      <span className="text-warning">{validationError}</span>
      <div className="d-flex justify-content-end gap-2 btn-container">
        <Button
          color="secondary"
          outline
          type="button"
          onClick={props.dismissModal}
        >
          <FormattedMessage id="Cancel" />
        </Button>
        <Button
          color="primary"
          outline
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <FormattedMessage id="Wait" />
          ) : (
            <FormattedMessage id="Add" />
          )}
        </Button>
      </div>
    </div>
  );
};

export default MoveStudentsToClassForm;
